import React, { Component } from 'react';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring/renderprops';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import { APIHandler, AppSettings, Background, StorageHandler, DataHandler, StoreButtons, ButtonBar } from 'C4';
import { storageKeys } from 'settings';

import 'react-toastify/dist/ReactToastify.css';

import logo from 'assets/images/logo/logo_white.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

const leading = (val) => `0${val}`.slice(-2);

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: 0,
      loading: true,
      backgroundImage: '',
      backgroundVideo: '',
      landingQuote: '',
    };

    this.setQuery = this.setQuery.bind(this);
  }

  async componentDidMount() {
    document.body.classList.add('no-scroll');
    await this.getAppSettings();

    this.mounted = true;

    this.init();
    this.getAppInfo();
  }

  componentWillUnmount() {
    this.mounted = false;
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  async getAppSettings() {
    const res = await AppSettings();
    if (res) this.setState({ loading: false });
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    this.setState({
      backgroundImage: appInfo?.background,
      backgroundVideo: appInfo?.video,
      landingQuote: appInfo?.landingQuote,
    });
  }

  async init() {
    const lastCheckedMessages = await StorageHandler.load(storageKeys.lastCheckedMessage);
    const initialState = {};

    if (lastCheckedMessages) initialState.lastCheckedMessages = lastCheckedMessages;
    await this.checkForUnreadMessages();

    const appId = await DataHandler.matchAppId();
    this.setState({ appId });

    const response = (await StorageHandler.load(storageKeys.user)) || {};
    const { user } = response;
    if (user) {
      const {
        training_graduated: graduated,
        training_started: started,
        sales_companion_registered: salesCompanionRegistered,
      } = user || {};

      if (graduated) initialState.userStatus = 'graduated';
      if (started) initialState.userStatus = 'continueTraining';

      if (!started && !graduated) initialState.userStatus = 'continueTraining';

      if (salesCompanionRegistered === null) {
        const d = new Date(Date.now());

        const obj = response;
        const { email } = obj;

        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

        const res = await APIHandler.updateUser(appId, email, [{ param: 'sales_companion_registered', val: date }]);

        if (res) {
          obj.sales_companion_registered = date;
          StorageHandler.save(storageKeys.user, obj);
        }
      }
    }

    const announcementShownBefore = await StorageHandler.exists(storageKeys.announcement);
    if (!announcementShownBefore) {
      const announcement = await APIHandler.getAnnouncement(appId);

      const { copy } = announcement;

      const ToastContent = () => (
        <div>
          <p>
            {copy}
            <a
              data-fancybox="rewards"
              data-type="iframe"
              data-src={`https://perurewards.travpromobile.com/?app_id=${appId}`}
              href={`https://perurewards.travpromobile.com/?app_id=${appId}`}
              key="rewards"
            >
              {i18n.translate('general.rewards')}
            </a>
          </p>
        </div>
      );

      if (announcement.length !== 0) {
        toast.info(ToastContent, {
          position: 'top-center',
          autoClose: false,
          closeOnClick: true,
          transition: Zoom,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
          toastId: 'announcement',
          onClose: () => StorageHandler.save(storageKeys.announcement, copy, 604800), // expires in a week
        });
      }
    }

    if (this.mounted) this.setState({ ...initialState });
  }

  async checkForUnreadMessages() {
    const { lastCheckedMessages } = this.state;
    const { missed_items: missedItems } = await DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      lastCheckedMessages,
    );
    const [{ count }] = missedItems;

    if (this.mounted) this.setState({ unreadMessageCount: count });
  }

  render() {
    const { unreadMessageCount, appId, loading, backgroundImage, backgroundVideo, landingQuote } = this.state;

    return (
      <div className="homeContainer">
        {loading && (
          <div className="loading">
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </div>
        )}
        {!loading && (
          <React.Fragment>
            <Background type="image" background={backgroundImage || null} />
            {/* <img src={`https://front.travpromobile.com/${appId}/logo.png`} className="homeLogo" alt="logo" /> */}
            <img src={logo} className="homeLogo" alt="logo" />
            <Spring
              from={{ transform: 'translateY(30%)', opacity: 0 }}
              to={{ transform: 'translateY(0%)', opacity: 1 }}
            >
              {(props) => (
                <div className="homeView" style={props}> 
                  <div className="homeView__title">
                    <h1>{landingQuote}</h1>
                    <hr className="shortLine" />
                    <div className="homeView__title--action">
                      <form>
                        <Link to="/main/search" onClick={this.setQuery}>
                          <button type="submit" className="searchButton">
                            <FontAwesomeIcon icon={['fas', 'search']} />
                          </button>
                        </Link>
                        <input
                          type="text"
                          placeholder={i18n.translate('general.search')}
                          onChange={({ target: { value: query } }) => {
                            this.setState({ query });
                          }}
                        />
                      </form>
                      {/* <Link to="/main/messages" className="startTrain btn">
                        <FontAwesomeIcon icon={['fas', 'envelope']} />
                        {unreadMessageCount === 0 && <p>{i18n.translate('nav.messages')}</p>}
                        {unreadMessageCount > 0 && (
                          <p>
                            {i18n.translate(
                              `${unreadMessageCount === 1 ? 'general.message' : 'general.messagePlural'}`,
                              {
                                count: unreadMessageCount,
                              },
                            )}
                          </p>
                        )}
                      </Link> */}
                    </div>
                  </div>
                </div>
              )}
            </Spring>
            <ToastContainer
              draggablePercent={60}
              autoClose={false}
              newestOnTop
              rtl={false}
              pauseOnVisibilityChange
              draggable
            />
            {/* <div className="buttonWrapper">
              <p>{i18n.translate('homeScreen.download')}</p>
              <StoreButtons />
            </div> */}
            <ButtonBar className="buttonBar" />
            <div className="topBar" />
            <div className="bottomBar" />
          </React.Fragment>
        )}
      </div>
    );
  }
}
